import { jsxs, jsx } from 'react/jsx-runtime';
import { Container, NoRightIcon, EmptyIcon } from './styled.mjs';
import { useIntlShort, Spacer, B2Regular } from '@moim/common';

function NoRight(_ref) {
  var textKey = _ref.textKey,
    textKeyValues = _ref.textKeyValues;
  var intl = useIntlShort();
  return jsxs(Container, {
    children: [jsx(NoRightIcon, {}), jsx(Spacer, {
      value: 8
    }), intl(textKey, textKeyValues), jsx(Spacer, {
      value: 14
    })]
  });
}
function Empty(_ref2) {
  var textKey = _ref2.textKey,
    textKeyValues = _ref2.textKeyValues;
  var intl = useIntlShort();
  return jsxs(Container, {
    children: [jsx(EmptyIcon, {}), jsx(Spacer, {
      value: 8
    }), jsx(B2Regular, {
      children: intl(textKey, textKeyValues)
    }), jsx(Spacer, {
      value: 14
    })]
  });
}
var BlockitFeedback = {
  NoRight: NoRight,
  Empty: Empty
};

export { BlockitFeedback };
